import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { usePublishedAnnouncementsQuery } from 'api/queries/announcements'
import { getUnreadAnnouncements } from 'lib/announcement-read-state'
import { pathsObj } from 'lib/constants/paths'
import BellIcon from './bell-icon'
import './announcement-button.scss'

const HINT_INTERVAL_MS = 60 * 1000
const HINT_DURATION_MS = 10 * 1000
const RING_START_DELAY_MS = 2 * 1000
const RING_STOP_DELAY_MS = 9 * 1000

const AnnouncementButton = () => {
  const navigate = useNavigate()
  const [isExpanded, setIsExpanded] = useState(false)
  const [isRinging, setIsRinging] = useState(false)
  const { data } = usePublishedAnnouncementsQuery()
  const unreadCount = getUnreadAnnouncements(data?.publishedAnnouncements ?? []).length
  const className = [
    'announcementButton',
    unreadCount ? 'announcementButton--hasUnread' : '',
    isExpanded ? 'announcementButton--expanded' : '',
    isRinging ? 'announcementButton--ringing' : '',
  ].filter(Boolean).join(' ')

  useEffect(() => {
    let collapseTimer: number | undefined
    let ringStartTimer: number | undefined
    let ringStopTimer: number | undefined
    const intervalTimer = window.setInterval(() => {
      window.clearTimeout(collapseTimer)
      window.clearTimeout(ringStartTimer)
      window.clearTimeout(ringStopTimer)
      setIsExpanded(true)
      setIsRinging(false)
      ringStartTimer = window.setTimeout(() => setIsRinging(true), RING_START_DELAY_MS)
      ringStopTimer = window.setTimeout(() => setIsRinging(false), RING_STOP_DELAY_MS)
      collapseTimer = window.setTimeout(() => setIsExpanded(false), HINT_DURATION_MS)
    }, HINT_INTERVAL_MS)

    return () => {
      window.clearInterval(intervalTimer)
      window.clearTimeout(collapseTimer)
      window.clearTimeout(ringStartTimer)
      window.clearTimeout(ringStopTimer)
    }
  }, [])

  return (
    <button
      aria-label={`Whats new${unreadCount ? `, ${unreadCount} unread` : ''}`}
      className={className}
      onClick={() => navigate(pathsObj.main.updates)}
      type="button"
    >
      <span className="announcementButton__bell">
        <BellIcon />
        {unreadCount > 0 && <span className="announcementButton__badge">{unreadCount}</span>}
      </span>
      {isExpanded && <span className="announcementButton__label">WHATS NEW</span>}
    </button>
  )
}

export default AnnouncementButton
